export enum AssetVerticalsEnum {
  BUILDING = 'BUILDING',
  HOME = 'HOME',
  RENT = 'RENT',
  OFFICE = 'OFFICE',
  PARKING_SLOT = 'PARKING_SLOT',
  NN_DISCOUNT_ALL_PARKINGS = 'NN_DISCOUNT_ALL_PARKINGS',
  BLOCKED = 'BLOCKED',
  HOTEL_ROOM = 'HOTEL_ROOM',
  HOTEL = 'HOTEL',
  VACATIONAL_RENTAL = 'VACATIONAL_RENTAL',
}

export interface RegisterAssetModel {
  id: string;
  clientId: string;
  community: string;
  alias?: string | null;
  type: string;
  streetType: string;
  streetName: string;
  blockNumber: string;
  staircase?: string | null;
  flat?: string | null;
  door?: string | null;
  city: string;
  postalCode: string;
  province: string;
  country: string;
  description: string | null;
  gatewayId?: string | null;
  qrGatewayId?: string | null;
}

export interface RegisterAssetPayload {
  id: string;
  attributes: {
    community: string;
    alias?: string;
    client_id: string;
    type: string;
    description?: string | null;
    location: {
      country: string;
      province: string;
      city: string;
      postal_code: string;
      street_type: string;
      street_name: string;
      block_number: string;
      staircase?: string | null;
      flat?: string | null;
      door?: string | null;
    };
  };
  relationship?: {
    gateways: {
      data: {
        gateways_id?: string | null;
        qr_gateway_id?: string | null;
      };
    };
  };
}

export interface AssetUpdateLocationPayload {
  country?: string;
  province?: string;
  city?: string;
  postal_code?: string;
  street_type?: string;
  street_name?: string;
  block_number?: string;
  staircase?: string;
  flat?: string;
  door?: string;
}

export interface AssetUpdateAttributesPayload {
  location: AssetUpdateLocationPayload;
  type: string;
  alias?: string;
  logo?: string;
  client_id?: string;
  community_id: string;
  is_blocked: boolean | null;
  description?: string;
  external_id?: string;
}

export interface AssetUpdatePayload {
  id: string;
  attributes: AssetUpdateAttributesPayload;
}

export interface AssetUpdateLocationModel {
  country?: string;
  province?: string;
  city?: string;
  postalCode?: string;
  streetType?: string;
  streetName?: string;
  blockNumber?: string;
  staircase?: string;
  flat?: string;
  door?: string;
}

export interface AssetUpdateModel {
  location: AssetUpdateLocationModel;
  type: string;
  alias?: string;
  logo?: string;
  clientId?: string;
  communityId: string;
  isBlocked: boolean | null;
  description?: string;
  externalId?: string;
}
